/* eslint-disable react-hooks/exhaustive-deps */
import { getReadableFormatNumber, numberToCommas } from "@/lib/utils/StringUtility";
import React from "react";
import { ActiveCardProps, LoadingStateProps } from "@/types/types.d";
import { SummaryCard } from "../../../Cards/SummaryCard";

type Props = {
  activeCard: ActiveCardProps;
  loading: LoadingStateProps;
  data: any;
  comparisonData: any;
  query: any;
  period: any;
  prevPeriod: any;
  comparisonPeriod?: any;
};

const ConversionRate = ({
  activeCard,
  loading,
  data,
  comparisonData,
  query,
  period,
  prevPeriod,
  comparisonPeriod
}: Props) => {
  const getComparisonPercentageDiff = () => {
    const percentageChange =
      ((data.conversion_rate - comparisonData.conversion_rate) / comparisonData.conversion_rate) *
      100;
    return Math.round(percentageChange);
  };

  return (
    <div data-cy="events-card">
      <SummaryCard
        cursor="cursor-default"
        activeCard={activeCard}
        title={"Conversion Rate"}
        onClick={() => {}}
        uniquekey={"conversion_rate"}
        card={"conversion_rate"}
        value={`${getReadableFormatNumber(data.conversion_rate)}%`}
        tooltip={`${numberToCommas(data.conversion_rate)} Conversion Rate`}
        runningDiff={data.conversion_rate_diff}
        runningDiffTooltip={`${data.conversion_rate_diff}% ${
          data.conversion_rate_diff > 0 ? "increase" : "decrease"
        } in conversion rate from previous period ${
          comparisonPeriod ? comparisonPeriod : prevPeriod
        } `}
        loading={loading}
        showRunningDiff={query?.period !== "live"}
        comparison={query?.comparison}
        comparisonPercentageDiff={getComparisonPercentageDiff()}
      />
    </div>
  );
};
const ConversionRateMemoized = React.memo(ConversionRate);
export { ConversionRateMemoized as ConversionRate };
